import React,{useEffect,useState} from 'react'
import {getSSOredirct} from "../services/Auth/AuthFetch"

function SSO() {
  const [error,setError]=useState(false)
  useEffect(()=>{
    try {
      getSSOredirct()
      setError(false)
    } catch (error) {
      setError(true)
    } 
    
  },[])
  
  return (
    <>
    
    {error ? <div className="sso-wrapper"><button className="sso-button" onClick={getSSOredirct}>SINGLE SIGN ON </button></div> :   <div className="sso-wrapper"><div className="sso-redirecting">Redirecting to SSO...</div></div>}
    </>
  )
}

export default SSO